import type { WProjectCustomizationPageView } from '@zola/svc-web-api-ts-client';

/**
 * Adjust the height or width of the card if it is folded.  Either the height
 * is scaled (landscape/folded) or the width (portrait/folded).
 */
export const getSizesPerOrientation = (
  width: number,
  height: number,
  isFolded: boolean,
  orientation: 'PORTRAIT' | 'LANDSCAPE' | undefined | WProjectCustomizationPageView.OrientationEnum
): [number, number] => {
  switch (orientation) {
    case 'PORTRAIT':
      return [isFolded ? width / 2 : width, height];

    case 'LANDSCAPE':
      return [width, isFolded ? height / 2 : height];

    default:
      return [width, height];
  }
};
